<template>
  <v-dialog persistent v-model="dialog" width="1000px" @keydown.esc="onDialogClose">
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>
    <v-alert v-model="alert" :type="alertType" dismissible>{{ alertMessage }}</v-alert>

    <v-row no-gutters>
      <v-col>
        <v-card color="white" flat tile>
          <v-card-title class="dialog-header-title">{{
            isBooking
              ? `Upload Booking Files - ${shipment_order_id}`
              : `Shipment Files Cabinet - ${shipment_order_id}`
          }}</v-card-title>

          <v-row>
            <v-divider class="py-0 my-0"></v-divider>
          </v-row>

          <v-card-text class="px-2 pt-1 pb-0">
            <v-row no-gutters>
              <v-col>
                <v-row class="px-2">
                  <v-alert type="info" dense tile>
                    <span class="body-2 font-weight-bold"
                      >Please ensure all uploaded documents are correct and complete.
                      Accele Freight will not be held for any penalties/charges arising
                      from inconsistencies in the documents uploaded.</span
                    >
                  </v-alert>
                </v-row>

                <v-row v-if="isBooking" no-gutters class="px-2 pt-2">
                  <v-col>
                    <v-alert type="info" dense tile border="left" text>
                      <v-row>
                        <span class="caption font-weight-bold"
                          >Please upload the required booking files with the following
                          tags:</span
                        >
                      </v-row>

                      <v-row>
                        <span class="caption font-weight-bold">
                          CINV:
                          <span class="font-weight-thin">Cargo invoice</span>
                        </span>
                      </v-row>

                      <v-row>
                        <span class="caption font-weight-bold">
                          CPL:
                          <span class="font-weight-thin">Cargo packing list</span>
                        </span>
                      </v-row>
                    </v-alert>
                  </v-col>
                </v-row>

                <v-row justify="end" class="px-2 pt-2">
                  <span class="font-weight-bold error--text caption"
                    >Note: Only PDF, JPG & PNG files are accepted</span
                  >
                </v-row>

                <v-row>
                  <v-divider class="mb-0"></v-divider>
                </v-row>

                <v-row no-gutters>
                  <v-col>
                    <file-cabinet-zone
                      :shipment_order_id="shipment_order_id"
                      :company_id="company_id"
                      :files="files"
                      v-on:updated="onFileUpdated"
                    ></file-cabinet-zone>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-row justify="end" class="pr-4">
              <v-btn
                color="error"
                tile
                depressed
                small
                class="font-weight-bold"
                @click="onDialogClose"
                >CLOSE</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import constant from "../../const";
import FilesCabinetZone from "@/components/shared/FilesCabinetZone.vue";
export default {
  props: ["value", "company_id", "dialog", "isBooking"],
  components: {
    FilesCabinetZone,
  },
  data() {
    return {
      CONSTANTS: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      alert: false,
      alertType: "success",
      alertMessage: "",

      shipment_order_id: null,

      files: [],

      files_updated: false,
    };
  },
  created() {},
  mounted() {},
  watch: {
    dialog: function () {
      if (this.dialog) {
        this.shipment_order_id = this.value;
        this.files_updated = false;
        this.files = [];
        this.loadFiles();
      } else {
        this.shipment_order_id = null;
      }
    },
  },
  methods: {
    /**
     * Load files for this company and shipment
     */
    async loadFiles() {
      this.$root.blockUImsg = "Loading files..";
      this.$root.blockUIshow = true;

      let resp = await this.$https.get(
        `/api/files/list?category=shipments&shipment_order_id=${this.shipment_order_id}`
      );

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.files = resp.data.data;
      } else {
        this.files = [];
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }
      this.$root.blockUIshow = false;
    },

    /**
     * on file updated
     */
    onFileUpdated() {
      this.files_updated = true;
    },

    /**
     * Send file upload notification email for newly uploaded files
     */
    async sendFileUploadNotification() {
      let fileIds = [];
      // if notification sent is false
      this.files.forEach((file) => {
        if (!file.notification_sent) {
          fileIds.push(file.file_id);
        }
      });

      // only send if fileIds is not empty
      if (fileIds.length > 0) {
        let postform = {
          company_id: this.company_id,
          shipment_order_id: this.shipment_order_id,
          file_ids: fileIds,
        };

        this.$https.post(`/api/files/upload_notification`, postform).then((resp) => {});
      }
    },

    /**
     * Close this dialog
     */
    onDialogClose() {
      this.sendFileUploadNotification();

      this.$emit("dialog-close", constant.DIALOG_FILE_CABINET, null, this.files_updated);
    },
  },
  computed: {},
};
</script>

<style scoped></style>
